/**
 * @file コンポーネント：フル動画ページタイムラインイベント ロジック管理
 */

// ライブラリ読み込み
import React from "react";

// Presenter読み込み
import { Presenter } from "./presenter";

// コンポーネントを返す
export const TimelineItemEvent = (props) => {
    return <Presenter {...props} />;
};
